import Chart from "common/components/Chart/Chart";
import { useNetworkGraphChart } from "hooks/chart/UseNetworkGraphChart";
import React, { useEffect, useRef } from "react";
import { NETWORKGRAPH } from "utils/constants";

const StaticNetworkChart = ({ data }) => {
    const {
        options: optionsStaticNetworkChart,
        setOptions: setOptionsStaticNetworkChart,
        showLoading,
        hideLoading,
    } = useNetworkGraphChart("", {
        enabled: true,
        useHTML: true,
        formatter: function () {
            return `
                <div white-space: normal;">
                    ${this.point.id} <b> (${this.point.marker.real_radius} links) </b>
                </div>
            `;
        },
    });

    useEffect(() => {
        if (data && Object.keys(data).length > 0) {
            showLoading(); // 🔹 Mostrar loading

            setTimeout(() => {
                setOptionsStaticNetworkChart({
                    ...optionsStaticNetworkChart,
                    series: [
                        {
                            ...optionsStaticNetworkChart.series[0],
                            data: data.links,
                            nodes: data.nodes,
                        },
                    ],
                });
                hideLoading();
            }, 100); // Simula un pequeño delay si querés
        } else {
            setOptionsStaticNetworkChart({
                ...optionsStaticNetworkChart,
                series: [
                    {
                        ...optionsStaticNetworkChart.series[0],
                        data: [],
                        nodes: [],
                    },
                ],
            });
        }
    }, [data]);

    return (
        <Chart
            options={optionsStaticNetworkChart}
            type={NETWORKGRAPH}
            onChartReady={(chart) => {
                showLoading.chartRef = chart;
            }}
        />
    );
};

export default StaticNetworkChart;
